import {
  Box,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useGetOne } from "react-admin";
import VerticalSpacer from "../../unit/VerticalSpacer";
import CustomerAccountIcon from "../../unit/svgIcon/CustomerAccountIcon";
import CustomerActiveIcon from "../../unit/svgIcon/CustomerActiveIcon";
import CustomerFinancialIcon from "../../unit/svgIcon/CustomerFinancialIcon";
import CustomerHistoryIcon from "../../unit/svgIcon/CustomerHistoryIcon";
import useNotify from "../../unit/useNotify";
import CustomStepsHeader from "../summary/CustomStepsHeader";
import CustomerActions from "../summary/CustomerActions";
import CustomerBaseDataAside from "../summary/CustomerBaseDataAside";
import CustomSummaryAccountTabList from "./CustomSummaryAccountTabList";
import CustomSummaryAdviceRequestList from "./CustomSummaryAdviceRequestList";
import CustomSummaryFinancialTabList from "./CustomSummaryFinancialTabList";
import CustomSummaryTabList from "./CustomSummaryTabList";
import { Email, EmailOutlined } from "@mui/icons-material";
import CustomSummaryMessageTabList from "./CustomSummaryMessageTabList";

const MainContent = styled("main")({
  height: `calc(100vh - 292px)`,
  overflowY: "auto",
  backgroundColor: "#fff",
});

const HeaderContent = styled("header")({
  position: "sticky",
  top: 0,
  marginBottom: "10px",
  paddingLeft: "0px",
  paddingRight: "0px",
  width: "100%",
  height: "120px",
  backgroundColor: "#f8f9f9",
});

const FooterContent = styled("footer")({
  background: "#fff",
  position: "sticky",
  paddingTop: "16px",
  paddingLeft: "0px",
  bottom: 0,
  width: "100%",
  height: "60px",
  borderTop: "1px solid #ddd",
});

interface RecordType {
  signup_time: any;
  verify_time: any;
  lastcheckmessage: any;
  calculated_time: any;
  last_login_time: "";
  applications?: {};
  paymentAccountData?: {};
  plaidAccountList?: {};
  adviceRequest?: {};
  counselorList?: {};
  plaidAccount?: {
    income_level: any;
    income_stability: any;
    spending_mix?: any;
    spending_within_means?: any;
    spending_stability?: any;
    savings_net_asset_mdb?: any;
    savings_net_asset_nsf?: any;
    savings_net_credit_mdb?: any;
    savings_net_safety?: any;
    financial_iq?: any;
    total_score?: any;
  };
}
const CustomSummaryTabShowBody = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [showTabOne, setShowTabOne] = useState(true);
  const [showTabTwo, setShowTabTwo] = useState(false);
  const [showTabThree, setShowTabThree] = useState(false);
  const [showTabFour, setShowTabFour] = useState(false);
  const [showTabFive, setShowTabFive] = useState(false);
  const [showTabSix, setShowTabSix] = useState(false);
  const [showTabSeven, setShowTabSeven] = useState(false);

  const userId = props.userId;

  const [record, setRecord] = useState<RecordType | undefined>(undefined);
  if (userId == "" || userId == undefined || userId == null) {
    return <Typography>Loading Error, missing User ID</Typography>;
  }

  const { data, isPending, error, isFetching } = useGetOne("customers", {
    id: userId,
  });

  useEffect(() => {
    setRecord(data);
  }, [userId, data]);

  if (error) {
    errorNotify("Error loading Loan " + error);
  }

  if (!record || record?.code == 201) {
    return <Typography>{record?.message || "Customer loading"}</Typography>;
  }
  if (isFetching || isPending)
    return <Typography sx={{ p: 5 }}>loading ...</Typography>;

  let adviceRequest: RecordType["adviceRequest"] =
    record && record.adviceRequest ? record.adviceRequest : undefined;

  let counselorList: RecordType["counselorList"] =
    record && record.counselorList ? record.counselorList : undefined;

  const handleShowTab = (tabnum: number) => {
    if (tabnum == 1 || tabnum == null) {
      setShowTabOne(true);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
      setShowTabSeven(false);
    } else if (tabnum == 2) {
      setShowTabOne(false);
      setShowTabTwo(true);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
      setShowTabSeven(false);
    } else if (tabnum == 3) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(true);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
      setShowTabSeven(false);
    } else if (tabnum == 4) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(true);
      setShowTabFive(false);
      setShowTabSix(false);
      setShowTabSeven(false);
    } else if (tabnum == 5) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(true);
      setShowTabSix(false);
      setShowTabSeven(false);
    } else if (tabnum == 6) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(true);
      setShowTabSeven(false);
    } else if (tabnum == 7) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
      setShowTabSeven(true);
    }
  };

  return (
    record && (
      <Grid container columnSpacing={1} sx={{ mb: 0 }}>
        <Grid
          item
          sx={{
            width: "300px",
            maxWidth: "300px",
            marginLeft: "0px",
            flexShrink: 0,
            mb: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <CustomerBaseDataAside userId={userId} record={record} />
        </Grid>
        <Grid
          item
          xs
          sx={{
            minWidth: 0,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            ml: "10px",
            padding: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <Grid container sx={{ width: "100%" }}>
            <Grid
              item
              sx={{ width: "calc(100% - 55px)" }}
              id={"rightbody-customer-summary-" + userId}
            >
              <Card sx={{ mt: 1, p: "10px", overflowY: "auto" }}>
                <HeaderContent id={"headercontent-customer-summary-" + userId}>
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#f8f9f9",
                      height: "120px",
                    }}
                  >
                    <CustomStepsHeader userId={userId} record={record} />
                  </Box>
                </HeaderContent>
                <MainContent id="maincontent-customer-summary">
                  {showTabOne ? (
                    <div
                      id="sectionOne"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <CustomSummaryTabList userId={userId} record={record} />
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* {showTabTwo && <></>} */}
                  {showTabThree ? (
                    <div
                      id="sectionThree"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <CustomSummaryFinancialTabList
                        userId={userId}
                        record={record}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {showTabFour ? (
                    <div
                      id="sectionFour"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <CustomSummaryAccountTabList
                        userId={userId}
                        record={record}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {showTabFive ? (
                    <div
                      id="sectionFive"
                      style={{ width: "100%", height: "100%" }}
                    ></div>
                  ) : (
                    <></>
                  )}
                  {showTabSix ? (
                    <div
                      id="sectionSix"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <CustomSummaryAdviceRequestList
                        userId={userId}
                        adviceRequest={adviceRequest}
                        counselorList={counselorList}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabSeven ? (
                    <div
                      id="sectionSeven"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <CustomSummaryMessageTabList
                        userId={userId}
                        record={record}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  <VerticalSpacer h={5} />
                </MainContent>
                <FooterContent>
                  <CustomerActions userId={userId} record={record} />
                </FooterContent>
              </Card>
            </Grid>
            <Grid
              item
              sx={{
                width: "50px",
                maxWidth: "50px",
                textAlign: "right",
                mt: 2,
                // border: "1px solid red",
              }}
              id={"rightaside-customer-summary-" + userId}
            >
              <Tooltip title="Activities" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(1)}
                  className={showTabOne ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-activities"
                >
                  <CustomerActiveIcon
                    color={showTabOne ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>

              <Tooltip title="Financials" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(3)}
                  // title="Financials"
                  className={showTabThree ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-financials"
                >
                  <CustomerFinancialIcon
                    color={showTabThree ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Accounts" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(4)}
                  // title="Accounts Status"
                  className={showTabFour ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-accounts"
                >
                  <CustomerAccountIcon
                    color={showTabFour ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Coaching History" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(6)}
                  // title="Advice History"
                  className={showTabSix ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-coaching"
                >
                  <CustomerHistoryIcon
                    color={showTabSix ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="System Messages in the Past 90 Days"
                placement="left-start"
              >
                <IconButton
                  onClick={() => handleShowTab(7)}
                  className={showTabSeven ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-messages"
                >
                  <EmailOutlined
                    sx={{ color: showTabSeven ? "white" : "#1976d2" }}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default CustomSummaryTabShowBody;
